import React, { Suspense, lazy } from "react";
import "./App.css";
import Nav from "./components/Nav/Nav";
import Hero from "./components/Hero/Hero";
// import About from "./components/About/About";
// import Project from "./components/Project/Project";
// import Skills from "./components/skills/Skills";
// import Services from "./components/Services/Services";
// import Freelance from "./components/Freelance/Freelance";
// import Contact from "./components/Contact/Contact";
// import Footer from "./components/Footer/Footer";


const About = lazy(()=> import("./components/About/About") )
const Project = lazy(()=> import("./components/Project/Project") )
const Skills = lazy(()=> import("./components/skills/Skills") )
const Services = lazy(()=> import("./components/Services/Services") )
const Freelance = lazy(()=> import("./components/Freelance/Freelance") )
const Contact = lazy(()=> import("./components/Contact/Contact") )
const Footer = lazy(()=> import("./components/Footer/Footer") )
function App() {
  return (
    <>
      <Nav />
      <Hero />
      <Suspense fallback={`<div> Loading<div/> `}>
        <Services />
        <Skills />
        <Freelance />
        <Project />
        <About />
        <Contact />
        <Footer />
      </Suspense>
    </>
  );
}

export default App;
